'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosThunderstormOutline = function IoIosThunderstormOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.6 21.3l-6.9 10 2.3-7.5h-4.1l1.2-6.3h5.6l-1.2 3.8h3.1z m1.2-7.8c2.8 0 5.1 2.3 5.1 5.1s-2.3 5.2-5.1 5.2h-0.6v-1.4h0.6c2.1 0 3.9-1.7 3.9-3.8s-1.8-3.9-3.9-3.9h-0.4l-1.1 0.1-0.3-1c-0.2-1.1-0.8-2.1-1.7-2.8s-1.9-1-3-1c-2.7 0-5 2.1-5 4.8v1l0.1 0.7c-0.4 0-0.9 0.1-1.1 0.1-1.5 0.3-2.5 1.4-2.5 2.9 0 0.8 0.2 1.5 0.7 2.1s1.3 0.8 2.1 0.8h0.8v1.4h-0.8c-2.2 0-4.1-1.9-4.1-4.2 0-2.1 1.6-4 3.7-4.1v-0.7c0-3.3 2.7-6.1 6.1-6.1 2.9 0 5.3 2.1 5.9 4.8h0.6z' })
        )
    );
};

exports.default = IoIosThunderstormOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-thunderstorm-outline.js
// module id = 2535
// module chunks = 0